import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { useT } from "@/lib/i18n";
export default function ThankYou() {
  const t = useT();
  return (<section className="py-20"><Seo title={t.seo_ty_title} description={t.seo_ty_desc} noindex /><div className="container-ar text-center"><h1 className="h1-hero text-4xl mb-6">{t.ty_title}</h1><Link to="/" className="btn-racing primary"><span>{t.ty_home}</span></Link></div></section>);
}
